import React from "react";
import Box from "@mui/material/Box";

export default function HtmlContent({ html, className, sx }: { html?: any; className?: string; sx?: any }){
	const __html: string = typeof html === 'string' ? html : (html?.processed || '');
	if (!__html) return null;
	return <Box {...{ className, sx }} dangerouslySetInnerHTML={{ __html }} />;
}
